import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePermissions } from '../hooks/usePermissions';
import LoadingScreen from './LoadingScreen';

const NavigateToDashboard: React.FC = () => {
  const { user, isImpersonating, loading, checkImpersonation } = useAuth();
  const { isAdmin, isSuperAdmin, isGroupAdmin, loadingGroupCheck: permissionsLoading } = usePermissions();

  // Verifica impersonazione solo una volta al mount
  useEffect(() => {
    if (!loading) {
      checkImpersonation();
    }
  }, []); // Solo al mount

  // Se si sta caricando, mostra loading
  if (loading || permissionsLoading) {
    return <LoadingScreen />;
  }

  // Se non c'è utente, reindirizza al login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Controlla se siamo in modalità "vedi admin" (per vedere temporaneamente l'area admin durante l'impersonazione)
  const viewAdminMode = localStorage.getItem('view_admin_mode') === 'true';
  
  // Controlla anche localStorage come fallback (per sicurezza)
  const impersonatedUserId = localStorage.getItem('impersonated_user_id');
  const impersonatedUserIdBackup = localStorage.getItem('impersonated_user_id_backup');
  
  // IMPORTANTE: Se non c'è impersonated_user_id, significa che l'impersonazione è stata terminata
  // e dobbiamo tornare all'area admin
  const hasActiveImpersonation = (isImpersonating || !!impersonatedUserId || !!impersonatedUserIdBackup) && !viewAdminMode;

  // Se si sta impersonando e non siamo in modalità "vedi admin",
  // usa comunque la home corretta dell'utente impersonato.
  if (hasActiveImpersonation) {
    if (isAdmin) {
      if (isGroupAdmin && !isSuperAdmin) {
        return <Navigate to="/group-dashboard" replace />;
      }
      return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/employee-dashboard" replace />;
  }
  
  // Se siamo in modalità "vedi admin", vai alla dashboard admin
  if (viewAdminMode && isAdmin) {
    if (isGroupAdmin && !isSuperAdmin) {
      return <Navigate to="/group-dashboard" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  // Se non si sta impersonando, vai alla dashboard appropriata in base al ruolo
  // IMPORTANTE: se l'utente ha capability admin di gruppo o super admin,
  // va sempre alla dashboard admin anche se il ruolo base utente non è "admin".
  if (isAdmin) {
    if (isGroupAdmin && !isSuperAdmin) {
      return <Navigate to="/group-dashboard" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  } else {
    return <Navigate to="/employee-dashboard" replace />;
  }
};

export default NavigateToDashboard;

